
// window.HS_SLIDE_CART_UPDATED = function(cart) {
//   window.HS_SLIDE_CART_OPEN()
// }

document.addEventListener("DOMContentLoaded", function () {

// real people real result
// var swiper = new Swiper(".mySwiper", {
//       spaceBetween: 10,
//       slidesPerView: 4,
//       freeMode: true,
//       watchSlidesProgress: true,
//     });
//     var swiper2 = new Swiper(".mySwiper2", {
//       spaceBetween: 10,
//       navigation: {
//         nextEl: ".swiper-button-next",
//         prevEl: ".swiper-button-prev",
//       },
//       thumbs: {
//         swiper: swiper,
//       },
//     });


// real people real result - script for read more real less
// var readMoreButtons = document.querySelectorAll('.read-more');

//     readMoreButtons.forEach(function(button) {
//       button.addEventListener('click', function() {
//         var container = this.closest('.experts-item');
//         var paragraphs = container.querySelectorAll('p');

//         paragraphs.forEach(function(paragraph) {
//           paragraph.classList.toggle('expanded');
//         });

//         this.textContent = (this.textContent === "Read More") ? "Read Less" : "Read More";
//       });
//     });


// Tabbed content functionality
document.querySelectorAll('.tab-a').forEach(function(tabA) {
    tabA.addEventListener('click', function() {
        // Remove active class from all tabs
        document.querySelectorAll('.tab').forEach(function(tab) {
            tab.classList.remove('tab-active');
        });

        // Add active class to the clicked tab
        var dataId = tabA.getAttribute('data-id');
        document.querySelector('.tab[data-id="' + dataId + '"]').classList.add('tab-active');

        // Remove active class from all tab links
        document.querySelectorAll('.tab-a').forEach(function(tabAElement) {
            tabAElement.classList.remove('active-a');
        });

        // Add active class to the clicked tab link
        tabA.classList.add('active-a');
    });
});

  // Tabbed content functionality section tabs-new
document.querySelectorAll('.tabs-new .tab-a').forEach(function(tabA) {
    tabA.addEventListener('click', function() {
        // Remove active class from all tabs
        document.querySelectorAll('.tabs-new .tab').forEach(function(tab) {
            tab.classList.remove('tab-active');
        });

        // Add active class to the clicked tab
        var dataId = tabA.getAttribute('data-id');
        document.querySelector('.tabs-new .tab[data-id="' + dataId + '"]').classList.add('tab-active');

        // Remove active class from all tab links
        document.querySelectorAll('.tabs-new .tab-a').forEach(function(tabAElement) {
            tabAElement.classList.remove('active-a');
        });

        // Add active class to the clicked tab link
        tabA.classList.add('active-a');
    });
});

    // Assuming you have an element with the class 'sticky-add-to-cart'
    var stickyAddToCart = document.querySelector('.sticky-add-to-cart');
    // Check if the element is found
    if (stickyAddToCart) {
        // Check if the element has the 'active' class
        if (stickyAddToCart.classList.contains('active')) {
            // If it has the 'active' class, find the child element with the class 'sticky-add-to-cart__inner'
            var innerElement = stickyAddToCart.querySelector('.sticky-add-to-cart__inner');
            // Check if the inner element is found
            if (innerElement) {
                // Apply the style to the inner element
                innerElement.style.transform = 'none';
            } else {
                console.error("Inner element not found");
            }
        } else {
            console.log("Sticky add-to-cart element does not have 'active' class");
        }
    } 
  
});


// ==================== SHOP FILTERS - CENTERD ACTIVE LINK ==========================

// Step 1: Store the clicked link's position in sessionStorage
document.querySelectorAll('.shop-filter .link-item a').forEach((link) => {
    link.addEventListener('click', (event) => {
        const linkOffsetLeft = link.offsetLeft;

        // Save the position to sessionStorage
        sessionStorage.setItem('scrollPosition', linkOffsetLeft);

      //  console.log('Link clicked, position saved:', linkOffsetLeft);
    });
});

// Step 2: Attempt to retrieve the position and scroll on page load
window.onload = () => {
    const container = document.querySelector('.shop-filter');
    const savedPosition = sessionStorage.getItem('scrollPosition');

  //  console.log('Window loaded, container found:', container);
 //   console.log('Saved Position (retrieved):', savedPosition);

    if (container && savedPosition) {
        // Delay the scroll to allow the DOM to finish loading
        setTimeout(() => {
            const containerWidth = container.clientWidth;
            const scrollPosition = savedPosition - containerWidth / 2;

          //  console.log('Container Width:', containerWidth);
         //   console.log('Calculated Scroll Position:', scrollPosition);

            // Scroll to the saved position
            if (CSS.supports('scroll-behavior', 'smooth')) {
                // Smooth scroll for supported browsers
                container.scrollTo({
                    left: scrollPosition,
                    behavior: 'smooth',
                });
            } else {
                // Fallback: Smooth scroll manually for unsupported browsers
                console.log('Fallback: Using manual scroll method for iOS');
                let start = container.scrollLeft;
                let end = scrollPosition;
                let change = end - start;
                let duration = 500; // 500ms for the scroll animation
                let startTime = performance.now();

                // Manual smooth scroll (simple linear interpolation)
                function animateScroll(timestamp) {
                    let timeElapsed = timestamp - startTime;
                    let progress = timeElapsed / duration;
                    progress = Math.min(progress, 1);

                    container.scrollLeft = start + change * progress;

                    if (progress < 1) {
                        window.requestAnimationFrame(animateScroll);
                    }
                }

                window.requestAnimationFrame(animateScroll);
            }

            // Clear the saved position after scrolling
            sessionStorage.removeItem('scrollPosition');
        }, 200); // Delay to ensure everything is loaded (adjust delay if needed)
    } else {
        console.log('Container not found or saved position missing');
    }
};

// Optional: Check sessionStorage directly in console
//console.log('sessionStorage on load:', sessionStorage);





// // Confetti Script

// function runOnStart(){
//   //alert("test runonstart");
// const mangoImages = document.querySelectorAll('.mango-img,.coconut-img,.pineapple-img,.protin-mango-img,.protin-pineapple-img,.sticker_protein');
//     const confettiPopup = document.querySelector('.confetti-popup');

//     mangoImages.forEach(function(mangoImg) {
//         mangoImg.addEventListener('click', function() {
//             const numConfetti = calculateNumConfetti();

//             for (let i = 0; i < numConfetti; i++) {
//                 const x = Math.random() * window.innerWidth; // Randomize the x-coordinate
//                 const y = -50; // Start from just above the screen
//                 createConfetti(x, y);
//             }
//            confettiPopup.classList.add('show');
//         });
//     });
// var closeButtons = document.querySelectorAll('.close-confe');
//     closeButtons.forEach(function(button) {
//         button.addEventListener('click', function() {
//             var confettiPopups = document.querySelectorAll('.confetti-popup');
//             confettiPopups.forEach(function(popup) {
//                 popup.classList.remove('show');
//             });
//         });
//     });
// }
// if(document.readyState !== 'loading') { runOnStart(); }
// else { document.addEventListener('DOMContentLoaded', function () { runOnStart() }); }



// function calculateNumConfetti() {
//     const screenWidth = window.innerWidth;
//     const confettiWidth = 56; // Adjust based on confetti image size

//     return Math.ceil(screenWidth / confettiWidth) * 2; // Double the number for denser coverage
// }

// function createConfetti(x, y) {
//     const images = [
//         'https://cdn.shopify.com/s/files/1/0281/7507/3373/t/120/assets/Fruit%20confetti_Mango.svg?v=1714465801', 
// 'https://cdn.shopify.com/s/files/1/0281/7507/3373/t/120/assets/Fruit%20confetti_Pineapple.svg?v=1714466007', 
// 'https://cdn.shopify.com/s/files/1/0281/7507/3373/t/120/assets/Fruit%20confetti_Coconut.svg?v=1714466082'
//     ];
//     const randomImage = images[Math.floor(Math.random() * images.length)];

//     const confetti = new Image();
//     confetti.className = 'confetti';
//     confetti.src = randomImage;
//     confetti.style.position = 'fixed';
//     confetti.style.width = '50px'; // Adjust image width
//     confetti.style.height = '56px'; // Adjust image height
//     confetti.style.left = x + 'px';
//     confetti.style.top = y + 'px';

//     document.body.appendChild(confetti);

//     const screenHeight = window.innerHeight;
//     const initialVelocityY = 5 + Math.random() * 5; // Set a constant vertical speed range
//     const initialVelocityX = (Math.random() - 0.5) * 2; // Add slight horizontal drift

//     let currentX = x;
//     let currentY = y;

//     function animateConfetti() {
//         currentX += initialVelocityX; // Horizontal movement
//         currentY += initialVelocityY; // Vertical movement

//         confetti.style.left = currentX + 'px';
//         confetti.style.top = currentY + 'px';

//         // Remove confetti if it goes off-screen
//         if (currentY < screenHeight) {
//             requestAnimationFrame(animateConfetti);
//         } else {
//             confetti.remove();
//         }
//     }

//     requestAnimationFrame(animateConfetti);
// }




